<template>
  <card>
    <h4>
      Отчет формируется с момента запуска модуля сбора логов - 1 октября 2022.
    </h4>
    <list
      v-if="$store.state.user.sections['report/scorings']"
      :columns="columns"
      :modalCreate="modalCreate"
      :removeLink="removeLink"
      :staticFilters="staticFilters"
      :cardLink="cardLink"
      :isUpdate="true"
      :filters="filters"
      :isAdd="false"
      :setImport="true"
      :exportFields="exportFields"
      :itemLink="itemLink"
      :dateFilter="dateFilter"
      :setLink="setLink"
      :openItem="true"
      :fields="fields"
      :params="params"
      :searchDisable="false"
      @change="change"
      @changeFunction="changeFunction"
      v-model="val"
    />
  </card>
</template>
<script>
export default {
  watch: {},
  name: "products",
  methods: {
    changeFunction(val) {},
    change(val) {},
  },
  data() {
    return {
      exportFields: {
        Дата: {
          field: "created_at",
          callback: (val) => {
            try {
              if (val && typeof val == "string") {
                return val;
              }
              return "Нет даты";
            } catch (error) {
              return val;
            }
          },
        },
        "Канал продаж": {
          field: "organizations",
          callback: (value) => {
            let organizations = "";
            for (let i = 0; i < value.length; i++) {
              organizations += value[i].name;
            }
            return organizations;
          },
        },
        Регион: "shop_region",
        "Точка продаж": "shop_name",
        Продавец: "user_name",
        "Контакт продавца": {
          field: "user_phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
        Партнер: "name",
        "Срок рассрочки": "month",
        Товары: {
          field: "purchases",
          callback: (value) => {
            let purchase = "";
            for (let i = 0; i < value.length; i++) {
              purchase += value[i].title;
            }
            return purchase;
          },
        },
        "Цена заказа": "total_price",
        "Номер клиента": {
          field: "client_phone",
          callback: (value) => {
            return "UZ " + value;
          },
        },
        "Результат скоринга": "scored",
        "Результат продажи": "paid",
      },
      staticFilters: [
        {
          title: "Фильтр по оплате",
          key: "paid",
          default: "0",
          items: [
            {
              id: "0",
              title: "Показать все",
            },
            {
              id: "1",
              title: "Оплачено",
            },
            {
              id: "2",
              title: "Не оплачено",
            },
          ],
        },
      ],
      dateFilter: [
        {
          key: "from_at",
          titleKey: "from_at",
          title: "Начало даты",
        },
        {
          key: "till_at",
          titleKey: "till_at",
          title: "Конец даты",
        },
      ],
      filters: [
        {
          key: "partner",
          title: "Фильтр по партнерам",
          titleKey: "name",
          field_key: "partner",
          selectKey: "name",
        },
        {
          key: "shop",
          title: "Фильтр по торговым точкам",
          titleKey: "name",
          field_key: "shop",
          selectKey: "name",
        },
        {
          key: "user",
          title: "Фильтр по сотрудникам",
          titleKey: "phone",
          field_key: "user",
          selectKey: "name",
        },
        {
          key: "organization",
          title: "Фильтр по организациям",
          titleKey: "name",
          field_key: "organization",
          selectKey: "name",
        },
      ],
      params: {},
      val: [],
      modalCreate: "business",
      fields: [],
      /** APIs */
      removeLink: "",
      cardLink: "",
      itemLink: "report/scorings",
      setLink: "report/scorings",
      columns: [
        {
          key: "created_at",
          title: "Дата",
          // dateTimeFormat: true,
        },
        {
          key: "organizations",
          title: "Канал продаж",
          object: "name",
          disableLink: true,
        },
        {
          key: "shop_region",
          title: "Регион",
        },
        {
          key: "shop_name",
          title: "Магазин",
        },
        {
          key: "user_name",
          title: "Продавец",
        },
        {
          key: "user_phone",
          title: "Контакты продавца",
        },
        {
          key: "name",
          title: "Партнер",
        },
        {
          key: "month",
          title: "Срок рассрочки",
        },
        {
          key: "purchases",
          object: "title",
          title: "Товары",
          disableLink: true,
        },

        {
          key: "total_price",
          title: "Цена заказа",
          price: true,
        },
        {
          key: "client_phone",
          title: "Номер клиента",
        },
        {
          key: "scored",
          title: "Результат скоринга",
        },
        {
          key: "paid",
          title: "Результат продажи",
        },
      ],
    };
  },
};
</script>
<style>
</style>
